import { toast } from 'react-toastify';

const TRACKING_CODE = '@correios/TRACKING_CODE';

function persistTrackingCode({ code, name }) {
    const newTracking = { name, code };
    const persisted = localStorage.getItem(TRACKING_CODE);
    let arrCodes = [];

    if (persisted) {
        localStorage.removeItem(TRACKING_CODE);

        arrCodes = JSON.parse(persisted);

        const codeExists = arrCodes.find(
            tranckCode => tranckCode.code === code
        );

        if (!codeExists) {
            arrCodes.push(newTracking);
        }
    } else {
        arrCodes = [newTracking];
    }

    localStorage.setItem(TRACKING_CODE, JSON.stringify(arrCodes));

    toast.info(`O código ${!name ? code : name}, foi salvo com sucesso`);

    return arrCodes;
}

function listTrackingCodes() {
    const persisted = localStorage.getItem(TRACKING_CODE);

    return JSON.parse(persisted) || [];
}

function getTrackingCode(trackingCode) {
    const persisted = localStorage.getItem(TRACKING_CODE);
    let arrCodes = [];
    let code = {};

    if (persisted) {
        arrCodes = JSON.parse(persisted);

        code = arrCodes.find(cd => cd.code === trackingCode);
    }

    return code || null;
}

function updateTrackingCode(codeName, trackingCode) {
    const objCode = [{ name: codeName, code: trackingCode }];
    const persisted = localStorage.getItem(TRACKING_CODE);
    let arrCodes = [];

    if (persisted) {
        localStorage.removeItem(TRACKING_CODE);

        arrCodes = JSON.parse(persisted);

        arrCodes = Object.assign(arrCodes, objCode);
    }

    localStorage.setItem(TRACKING_CODE, JSON.stringify(arrCodes));

    return arrCodes;
}

function removeTrackingCode(trackingCode) {
    const persisted = localStorage.getItem(TRACKING_CODE);
    let arrCodes = [];

    if (persisted) {
        localStorage.removeItem(TRACKING_CODE);

        arrCodes = JSON.parse(persisted);

        arrCodes = arrCodes.filter(item => item.code !== trackingCode);
    }

    localStorage.setItem(TRACKING_CODE, JSON.stringify(arrCodes));

    toast.info(`Você deletou o código ${trackingCode}`);
}

export {
    persistTrackingCode,
    listTrackingCodes,
    updateTrackingCode,
    getTrackingCode,
    removeTrackingCode,
};
